import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClassName from 'classnames'

export default class MetaRadio extends Component {
    isEmpty() {
        if (this.props.checked === undefined) {
            return true
        }
        return false
    }

    _click() {
      //  if (this.props.setMetaData !== undefined) this.props.setMetaData(this.props.index, this.props.group)
    }

    render() {
        return <input className={ClassName('meta', this.isEmpty() ? 'AddMeta' : '')} type="radio" name={`group${this.props.group}`} style={this.props.position} onClick={(e) => this._click()} checked={this.props.checked} />
    }
}

MetaRadio.propTypes = {
    position: PropTypes.object.isRequired,
    checked: PropTypes.bool,
    index: PropTypes.number.isRequired,
    group: PropTypes.number.isRequired,
    setMetaData: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/MetaRadio.js